'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.publishEmailCaptureResponseMessage = exports.default = undefined;

var _pipe = require('transmute/pipe');

var _pipe2 = _interopRequireDefault(_pipe);

var _buildUnpublishedMessage = require('conversations-schema/factories/PubNubMessageFactory/buildUnpublishedMessage');

var _senderTypes = require('conversations-schema/pubnub-message/constants/senderTypes');

var _SenderIds = require('conversations-schema/constants/SenderIds');

var _EmailCaptureResponseMetadata = require('conversations-schema/records/PubNubMessageMetadata/EmailCaptureResponseMetadata');

var _EmailCaptureResponseMetadata2 = _interopRequireDefault(_EmailCaptureResponseMetadata);

var _threadGetters = require('conversations-schema/thread/operators/threadGetters');

var _publishMessageToConversation = require('../../actions/PublishActions/publishMessageToConversation');

var _getThreadByChannel = require('../../threads/selectors/getThreadByChannel');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var publishEmailCaptureResponseMessage = function publishEmailCaptureResponseMessage(_ref) {
  var channel = _ref.channel,
      email = _ref.email;
  return function (dispatch, getState) {
    var threadId = (0, _pipe2.default)(function (state) {
      return (0, _getThreadByChannel.getThreadByChannel)(state, { channel: channel });
    }, _threadGetters.getThreadId)(getState());

    var message = (0, _buildUnpublishedMessage.buildUnpublishedMessage)({
      descriptor: {
        channel: channel
      },
      metadata: new _EmailCaptureResponseMetadata2.default({
        email: email
      }),
      senderId: _SenderIds.SYSTEM_ID,
      senderType: _senderTypes.SYSTEM,
      threadId: threadId
    });

    dispatch((0, _publishMessageToConversation.publishMessageToConversation)({ channel: channel, message: message }));
  };
};

exports.default = publishEmailCaptureResponseMessage;
exports.publishEmailCaptureResponseMessage = publishEmailCaptureResponseMessage;


//////////////////
// WEBPACK FOOTER
// ./js/email-capture/actions/publishEmailCaptureResponseMessage.js
// module id = 518
// module chunks = 2 3